import { createPurchaseEvent, getPurchaseEvents } from 'lib/api'
import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { normalizePurchaseEvent, PurchaseEvent, PURCHASE_EVENTS_STORE_SIZE } from 'shared'
import { useTaxationStore } from './useTaxationStore'

export const useFetchPurchaseEvents = () => {
  const { purchaseEvents, setPurchaseEvents } = useTaxationStore()
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  loading

  const fetchPurchaseEvents = useCallback(
    async (currentPage: number) => {
      setLoading(true)
      const events: PurchaseEvent[] = []
      let nextPage = false
      try {
        const { purchaseEvents, hasNextPage } = await getPurchaseEvents(currentPage)
        if (purchaseEvents) {
          for (const item of purchaseEvents) {
            const purchaseEvent = normalizePurchaseEvent(item)
            events.push(purchaseEvent)
          }

          // setPurchaseEvents(events)
          if (currentPage === 1) {
            setPurchaseEvents(
              events
                .filter((events) => !events.lotNumber?.startsWith('Unassigned-'))
                .slice(0, PURCHASE_EVENTS_STORE_SIZE)
            )
          }
        } else setPurchaseEvents([])

        nextPage = hasNextPage
        return { events, nextPage }
      } catch (e) {
        enqueueSnackbar('error in loading purchase events', { variant: 'error' })
        return { events: [], nextPage: false }
      } finally {
        setLoading(false)
      }
    },
    [setPurchaseEvents]
  )

  const handleCreatePurchaseEvent = useCallback(
    async (event: any) => {
      try {
        const response = await createPurchaseEvent(event)
        if (response) {
          const purchaseEvent = normalizePurchaseEvent(response)
          const totalQuantity = purchaseEvent.purchases.reduce((acc, art) => acc + art.quantity, 0)
          const totalPrice = purchaseEvent.purchases.reduce((acc, art) => acc + art.price, 0)
          purchaseEvent.totalRegisteredPrice = totalPrice
          purchaseEvent.totalRegisteredQuantity = totalQuantity

          const current = useTaxationStore.getState().purchaseEvents
          setPurchaseEvents([purchaseEvent, ...current]) // insert new purchase event as first item of the list

          return purchaseEvent
        }
      } catch (e) {
        console.log(e)
        return null
      }
    },
    [setPurchaseEvents]
  )

  const updateStoresPurchaseEvent = (event: PurchaseEvent) => {
    const idx = purchaseEvents.findIndex((x) => x.id === event.id)
    if (idx === -1) return

    const next = [...purchaseEvents]
    next[idx] = { ...next[idx], ...event }

    setPurchaseEvents(next)
  }

  return {
    purchaseEvents,
    loading,
    fetchPurchaseEvents,
    handleCreatePurchaseEvent,
    updateStoresPurchaseEvent,
  }
}
